export default __webpack_public_path__ + "static/media/ProductManagementGuide.6e2bd162.png";